export default "__VITE_ASSET__4dd57061__"